import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Резолвер объекта для формы создания технического устройства.
 * При создании ТУ у URL указывается id объекта, для которого создается ТУ (например /technical-device/new?object=11).
 * Если такого параметра нет или id объекта невалидно (нет его или нет прав), то делаем редирект.
 */
@Injectable()
export class TechnicalDeviceObjectForCreateResolverService extends BaseResolverService {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        service: WorkingObjectsApiService,
        router: Router,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        /**
         * Достаем id объекта из урла вида /technical-device/new?object=11
         */
        const objectId = snapshot.params.objectId || null;

        if (!objectId) {
            this.redirect();
            return {};
        }

        return {
            id: objectId
        };
    }

    processNullData() {
        this.redirect();
    }

    processError() {
        this.redirect();
    }
}
